import { createSlice } from '@reduxjs/toolkit'
import {
  addMaturityScoring,
  deleteMaturityScoring,
  getMaturityScoringBySubDomainId,
  getMaturityScorings,
  updateMaturityScoringAction,
} from './maturityScoringActions'
import {
  MaturityScoring,
  MaturityScoringResponse,
} from '../../types/maturityScoringTypes'

interface MaturityScoringState {
  maturityScorings: MaturityScoring[]
  loading: boolean
  maturityScoring: MaturityScoring | null
  error: string | null
  addedMaturityScoring: MaturityScoring | null
  updatedMaturityScoring: MaturityScoring | null
  MaturityScoringResponse: MaturityScoringResponse | null
  sourceMaturityScorings: MaturityScoring[]
  MaturityScoringBySubDomainId: MaturityScoring | null
}

const initialState: MaturityScoringState = {
  maturityScorings: [],
  loading: false,
  error: null,
  addedMaturityScoring: null,
  maturityScoring: null,
  updatedMaturityScoring: null,
  MaturityScoringResponse: null,
  sourceMaturityScorings: [],
  MaturityScoringBySubDomainId: null,
}

export const maturityScoringSlice = createSlice({
  name: 'maturityScoring',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMaturityScorings.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getMaturityScorings.fulfilled, (state, action) => {
        state.loading = false
        state.MaturityScoringResponse = {
          maturityScoring: action.payload.maturityScorings,
          totalPages: action.payload.totalPages ?? 0,
          total: action.payload.total ?? 0,
        }
      })
      .addCase(getMaturityScorings.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(deleteMaturityScoring.fulfilled, (state, action) => {
        state.loading = false
        const deletedMaturityScoringId = action.meta.arg

        if (state.MaturityScoringResponse) {
          state.MaturityScoringResponse.maturityScoring = (
            state.MaturityScoringResponse.maturityScoring ?? []
          ).filter(
            (maturityScoring) =>
              maturityScoring._id !== deletedMaturityScoringId
          )

          state.MaturityScoringResponse.total =
            state.MaturityScoringResponse.total ?? 0
          state.MaturityScoringResponse.totalPages =
            state.MaturityScoringResponse.totalPages ?? 0
          state.MaturityScoringResponse.currentPage =
            state.MaturityScoringResponse.currentPage ?? 0
        }

        if (state.maturityScorings) {
          state.maturityScorings = (state.maturityScorings ?? []).filter(
            (maturityScoring) =>
              maturityScoring._id !== deletedMaturityScoringId
          )
        }
      })
      .addCase(addMaturityScoring.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addMaturityScoring.fulfilled, (state, action) => {
        state.loading = false
        state.addedMaturityScoring = action.payload
        state.maturityScorings.push(action.payload)
      })
      .addCase(addMaturityScoring.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(updateMaturityScoringAction.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateMaturityScoringAction.fulfilled, (state, action) => {
        state.loading = false
        state.updatedMaturityScoring = action.payload
      })
      .addCase(updateMaturityScoringAction.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(getMaturityScoringBySubDomainId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getMaturityScoringBySubDomainId.fulfilled, (state, action) => {
        state.loading = false
        state.MaturityScoringBySubDomainId = action.payload
      })
      .addCase(getMaturityScoringBySubDomainId.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
  },
})

export default maturityScoringSlice.reducer
